import styled from 'styled-components/macro'

export const Container = styled.div`
  z-index: 99;
  pointer-events: auto;
`
